module.exports = __webpack_public_path__ + "img/sub_icon2.9910cc8e.svg";